import React from "react";

import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";

import {
  Table,
  Input,
  Select,
  Tag,
  Button,
  DatePicker,
  Popconfirm,
} from "antd";
import moment from "moment";
const { RangePicker } = DatePicker;
const { Option } = Select;

const EditableContext = React.createContext();

class EditableCell extends React.Component {
  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;

    let returnComponent = null;
    let usersOptions = [];
    // let selectedUsers = "";
    let selectedUsers = [];

    const select1Options = [];
    const select1Tag = [];

    if (inputType === "select1") {
      if (this.props.userdata) {
        this.props.userdata.forEach((d) => {
          select1Options.push(
            <Option
              key={"s1" + d._id}
              value={d._id}
              disabled={d.email ? false : true}
            >
              {d.name} - {d.user_name} -{" "}
              {d.email ? d.email : <b>No user email</b>}
            </Option>
          );

          if (record[dataIndex] == d._id) {
            select1Tag.push(
              <Tag key={d._id}>
                {d.name} - {d.user_name} - {d.email}
              </Tag>
            );
          }
        });
      }
    }

    if (inputType === "select2") {
      if (this.props.userdata) {
        this.props.userdata.forEach((d) => {
          select1Options.push(
            <Option
              key={"s2" + d._id}
              value={d._id}
              disabled={d.email ? false : true}
              // title={`${d.hotel_code} - ${d.hotel_name}`}
            >
              {`${d.name} - ${d.user_name} - ${d.email ? d.email : <b>No user email</b>}`}
              
            </Option>
          );

          if (record[dataIndex] == d._id) {
            select1Tag.push(
              <Tag key={d._id}>
                {d.name} - {d.user_name} - {d.email}
              </Tag>
            );
          }
        });
      }
    }

    if (inputType === "select") {
      this.props.userdata.forEach((d) => {
        usersOptions.push(
          <Option key={"d" + d._id} value={d._id}>
            {d.name} - ( {d.user_name} )
          </Option>
        );

        if (record[dataIndex].includes(d._id)) {
          // selectedUsers += d.name + " (" + d.userName + ")  \n";
          selectedUsers.push(
            <Tag key={d._id}>
              {d.name} ( {d.user_name} ){" "}
            </Tag>
          );
        }
      });
    }

    if (editing) {
      if (inputType === "date1") {
        returnComponent = (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: "Please Input duration",
                },
              ],
              initialValue: [
                moment(record["start_date"]),
                moment(record["end_date"]),
              ],
            })(
              <RangePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD HH:mm"
                style={{ width: "100%" }}
              />
            )}
          </Form.Item>
        );
      }
      if (inputType === "select1") {
        returnComponent = (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: "Please Enter Assigner",
                },
              ],
              initialValue: record[dataIndex],
            })(
              <Select
                showSearch
                placeholder="Enter Assigner"
                optionFilterProp="children"
                notFoundContent={null}
                style={{ width: "500px" }}
              >
                {select1Options}
              </Select>
            )}
          </Form.Item>
        );
      }
      if (inputType === "select2") {
        returnComponent = (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: "Please Enter Assignee",
                },
              ],
              initialValue: record[dataIndex],
            })(
              <Select
                showSearch
                placeholder="Select Assignee"
                optionFilterProp="children"
                notFoundContent={null}
                style={{ width: "500px" }}
              >
                {select1Options}
              </Select>
            )}
          </Form.Item>
        );
      }
    } else {
      if (inputType === "select1" || inputType === "select2") {
        returnComponent = select1Tag;
      } else if (inputType === "date1") {
        // returnComponent = (<div>{moment(record["start_date"], 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')}</div>);
        returnComponent = (
          <div>
            {moment(record["start_date"]).format("YYYY-MM-DD HH:mm")} -{" "}
            {moment(record["end_date"]).format("YYYY-MM-DD HH:mm")}
          </div>
        );
      } else {
        returnComponent = children;
      }
    }

    return <td {...restProps}>{returnComponent}</td>;
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

class EditableTable extends React.Component {
  state = {
    data: [],
    signersGroupsGetData: [],
    editingKey: "",
  };

  async componentDidMount() {
    await this.setState({
      data: this.props.signersGroupsGetData.out_of_office,
      signersGroupsGetData: this.props.signersGroupsGetData,
    });
  }

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     data: this.props.signersGroupsGetData.out_of_office,
  //     signersGroupsGetData: this.props.signersGroupsGetData,
  //     editingKey: ""
  //   };

  // }

  async componentDidUpdate(prevProps, prevState) {
    // if (prevState.data !== this.props.signersGroupsGetData.out_of_office) {
    //   this.setState({ data: this.props.signersGroupsGetData.out_of_office });

    //   this.props.form.resetFields();
    // }

    if (prevProps.signersGroupsGetData !== this.props.signersGroupsGetData) {
      await this.setState({
        data: this.props.signersGroupsGetData.out_of_office,
        signersGroupsGetData: this.props.signersGroupsGetData,
      });

      // this.props.form.resetFields();
    }
  }

  isEditing = (record) => record._id === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: "" });
  };

  save(form, key) {
    form.validateFields(async (error, values) => {
      if (error) {
        return;
      }

      values._id = key;

      // let sendValues = {};
      // sendValues._id = key;
      // sendValues.signers_group_name = values.signers_group_name;
      // sendValues.signers_group_users = values.signers_group_users;

      if (await this.props.saveGroup(values)) {
        this.setState({ editingKey: "" });
      } else {
      }
    });
  }

  edit(key) {
    this.setState({ editingKey: key });
  }

  // delete(key) {
  //   if ( this.props.delete(key)) {

  //   }
  // }

  // components = {
  //   body: {
  //     cell: EditableCell
  //   }
  // };

  render() {
    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns1 = [
      {
        title: "Assigner",
        dataIndex: "assigner",
        editable: true,
        inputType: "select1",
        userData: this.state.signersGroupsGetData.users,
        width: "500px",
      },
      {
        title: "Assignee",
        dataIndex: "assignee",
        editable: true,
        inputType: "select2",
        userData: this.state.signersGroupsGetData.out_of_office_all_users,
        width: "500px",
      },
      {
        title: "Duration",
        dataIndex: "duration",
        editable: true,
        inputType: "date1",
        // width: "370px",
      },
      {
        title: "Action",
        dataIndex: "operation",
        width: "220px",
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {(form) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.save(form, record._id)}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </Button>
                )}
              </EditableContext.Consumer>

              <Button
                size="small"
                type="danger"
                onClick={() => this.cancel(record._id)}
              >
                Cancel
              </Button>
            </span>
          ) : (
            <div>
              <Button
                type="primary"
                size="small"
                disabled={editingKey !== ""}
                onClick={() => this.edit(record._id)}
                style={{ marginRight: 8 }}
              >
                Edit
              </Button>

              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => this.props.delete(record._id)}
              >
                <Button size="small" disabled={editingKey !== ""} type="danger">
                  Delete
                </Button>
              </Popconfirm>
            </div>
          );
        },
      },
    ];

    const columns = columns1.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: col.inputType,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
          userdata: col.userData,
        }),
      };
    });

    return (
      <EditableContext.Provider value={this.props.form}>
        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
          rowKey="_id"
          pagination={false}
          className="is_table_2"
          scroll={{ x: 1600 }}
        />
      </EditableContext.Provider>
    );
  }
}

const EditableFormTable = Form.create()(EditableTable);

export default EditableFormTable;
